
import Vue, { PropType } from 'vue'
import { Secondhand } from '@/models'

import SecondhandListItem from './SecondhandListItem.vue'

export default Vue.extend({
  name: 'SecondhandList',

  props: {
    secondhands: Array as PropType<Array<Secondhand>>,
  },

  components: {
    SecondhandListItem,
  },
})
